import { Location, Redirect, Router } from '@reach/router';
import CannotSignInMyOPSWAT from 'pages/troubleshooting/cannot-sign-in-my-opswat';
import { HelmetProvider } from 'react-helmet-async';

import CommonContextV2Provider from 'components/v2/common-context';

import Page404 from './pages/404/404';
import AcceptedInvite from './pages/accepted-invite/acceptedInvite';
import Active from './pages/active/active';
import ErrorBoundary from './pages/error-boundary/errorBoundary';
import LogoutPage from './pages/logout/logout';
import Profile from './pages/profile/profile';
import ResetIpWhitelist from './pages/reset-ip-whitelist/resetIpWhitelist';

import ChangePasswordPageV2 from 'pages/v2/change-password';
import ConfirmDisableMfaPage from 'pages/v2/confirm-disable-mfa';
import ConfirmEmailPageV2 from 'pages/v2/confirm-email';
import ConsentPageV2 from 'pages/v2/consent';
import RegisterPageV2 from 'pages/v2/register';
import ResetPasswordPageV2 from 'pages/v2/reset-password';
import LoginPageV2 from './pages/v2/login';

import gtmService from './services/gtmService';

function App() {
    return (
        <HelmetProvider>
            <ErrorBoundary>
                <Location>
                    {({ location }) => {
                        gtmService.sendRouteChangeEvent(location.pathname);
                        return (
                            <CommonContextV2Provider location={location}>
                                <Router>
                                    {/* redirects for legacy urls */}
                                    <Redirect from='/' to='/login' noThrow />
                                    <Redirect from='/opswatLogin' to='/login' noThrow />
                                    <Redirect from='/communityRegistration' to='/register' noThrow />
                                    <Redirect from='/communityRegistration' to='/register' noThrow />
                                    <Redirect from='/channel-partner-login' to='/login' noThrow />
                                    <Redirect from='/channel-partner-register' to='/register' noThrow />

                                    {/* newly revamped ui DIG-5984 */}
                                    <LoginPageV2 path='/login' />
                                    <RegisterPageV2 path='/register' />
                                    <ConfirmEmailPageV2 path='confirmEmail' />
                                    <ConfirmDisableMfaPage path='confirm-mfa-disable' />
                                    <ConsentPageV2 path='consent' />
                                    <ResetPasswordPageV2 path='resetPassword' />
                                    <ChangePasswordPageV2 path='changePassword' />

                                    {/* legacy ui */}
                                    <LogoutPage path='/logout' />
                                    <Active path='active' />
                                    <Profile key={'profilePage'} path=':pageType' />
                                    <Profile key={'profilePage'} path=':pageType/:page' />
                                    <Profile key={'profilePage'} path=':pageType/:orgId/:page' />
                                    <AcceptedInvite path='accepted-invite' />
                                    <ResetIpWhitelist path='reset-ip-whitelist' />
                                    <CannotSignInMyOPSWAT path='/troubleshooting/cannot-sign-in-my-opswat' />

                                    <Page404 default />
                                </Router>
                            </CommonContextV2Provider>
                        );
                    }}
                </Location>
            </ErrorBoundary>
        </HelmetProvider>
    );
}

export default App;
